module.exports = __webpack_public_path__ + "static/media/Raum_23.30a4f12e.jpg";